import React from 'react';
import { Box, Card, CardHeader, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import BatteryChart from './BatteryChart';
import StatusChip from './StatusChip';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.BatteryCard.header.title',
        defaultMessage: 'Battery reading',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.BatteryCard.header.subTitle',
        defaultMessage: 'Battery voltage, current and level available on the vehicle',
    },
});
function BatteryCard({ realtimeMetrics, lastMetrics, refreshInterval }) {
    const intl = useIntl();
    const batteries = realtimeMetrics?.filter((e) => e.battery).map((e) => e.battery);
    const battery = batteries && batteries.length > 0 ? batteries[batteries.length - 1] : lastMetrics?.battery;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => !!e.battery }) }),
        React.createElement(CardContent, null,
            realtimeMetrics ? (React.createElement(Box, { sx: { height: 120 } },
                React.createElement(BatteryChart, { data: realtimeMetrics, refreshInterval: refreshInterval }))) : null,
            React.createElement(TableContainer, { component: Paper, elevation: 0 },
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "Voltage"),
                            React.createElement(TableCell, { align: "right" }, "Level"),
                            React.createElement(TableCell, { align: "right" }, "Current"))),
                    React.createElement(TableBody, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right", "data-testid": "battery-voltage" }, battery?.voltage || battery?.voltage === 0 ? `${battery.voltage.toFixed(2)} \u33B7` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "battery-level" }, battery?.level || battery?.level === 0 ? `${battery.level.toFixed(2)}` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "battery-current" }, battery?.current || battery?.current === 0 ? `${battery.current.toFixed(2)} dA` : '-'))))))));
}
export default React.memo(BatteryCard);
